import React, { useEffect, useState } from 'react';
import Styles from './PageSimulador.css';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { useRouter } from 'next/router';
import { devLog, getEnvAwareValue, isBrowser, parseURLParams } from '../../../../utils/browser';
import FormBasicInfo from '../FormBasicInfo/FormBasicInfo';
import Footer24 from '../../../../components/organisms/Footer24';
import { Stepper } from './Stepper';
import ApartmentRedirect from '../ApartmentRedirect/ApartmentRedirect';
import StoreNotFound from '../StoreNotFound/StoreNotFound';
import StoreProposalSent from '../StoreProposalSent/StoreProposalSent';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import FormProposal from '../FormProposal/FormProposal';
import LoadingModal from '../../../../components/organisms/LoadingModal';
import Confirmation from '../Confirmation/Confirmation';
import FormPersonalData from '../FormPersonalData/FormPersonalData';
import FinalMessage from '../FinalMessage/FinalMessage';
import clsx from 'clsx';
import Header24 from '../../../../components/organisms/Header24';
import Button from '../../widgets/Button/Button';

function PageSimulador() {
  const {
    isMobile,
    formLanding,
    simulationExclusiveView,
    simulationStep,
    loading,
    hideFooter,
    restartSimulation,
    loadingProps,
    loadSimulationFromPreviousStep,
    modalVoucher,
    setModalVoucher,
    proposalId,
  } = useSimuladorEnergiaSolarState();
  const router = useRouter();

  const showVoucher = isMobile && modalVoucher;
  const [sentProposalId, setSentProposalId] = useState();

  useEffect(() => {
    if (!isBrowser()) return;
    if (!simulationExclusiveView) return;

    router.replace(
      router.pathname,
      parseURLParams(router.asPath, 'energia-solar-fotovoltaica-orcamento', {
        etapa: simulationStep?.id,
      }),
      {
        scroll: false,
        shallow: false,
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simulationExclusiveView, simulationStep?.id]);

  useEffect(() => {
    if (!isBrowser() || (!!formLanding && !!formLanding?.document)) return;

    const sim = loadSimulationFromPreviousStep();

    if (!sim) {
      restartSimulation();

      window.location.href = getEnvAwareValue(
        './energia-solar-fotovoltaica.html#form-energia-solar',
        './energia-solar-fotovoltaica#form-energia-solar',
      );

      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formLanding]);

  useEffect(() => {
    if (!isBrowser()) return;
    if (!proposalId) return;
    if (`${proposalId}` === `${sentProposalId}`) {
      devLog(`[PROPOSAL: ${proposalId}] already sent to dataLayer`);
      return;
    }

    window.dataLayer = window.dataLayer || [];

    try {
      devLog(`[PROPOSAL: ${proposalId}]`);
      window.dataLayer.push({
        event: 'update-proposal-id',
        proposalId: `${proposalId}`,
      });
      setSentProposalId(`${proposalId}`);
    } catch (error) {
      devLog('Error sending error message to dataLayer', error);
    }
  }, [proposalId, sentProposalId]);

  return (
    <>
      <Header24
        disableMenu
        disableMenuDesktop
        hideAreaCliente
        showSearch={false}
        className={`fix-z-index simulacao-energia-solar ${showVoucher ? 'with-voucher' : ''}`}
        alternativeLogo="assets/simulador-energia-solar/jornada/logo-santander.svg"
      >
        {showVoucher && (
          <div className="voucher-header-mobile">
            <Button
              variant="flat"
              onClick={(ev) => {
                ev.preventDefault();

                if (loading) return;

                setModalVoucher(false);
              }}
            >
              <img alt="" src="assets/simulador-energia-solar/jornada/ic-arrow-back-white.svg" />
            </Button>
            <p>Inserir cupom</p>
            <span />
          </div>
        )}
      </Header24>

      <section id="jornada-simulacao" className={clsx('jornada-simulacao', simulationStep?.id)}>
        <Stepper />
        <FormBasicInfo />

        <ApartmentRedirect />
        <StoreNotFound />
        <StoreProposalSent />
        <FormProposal />
        <Confirmation />
        <FormPersonalData />

        <ErrorMessage />
        <FinalMessage />

        {loading && <LoadingModal {...loadingProps} />}
      </section>

      <input type="hidden" id="proposal-id" value={proposalId} data-value={proposalId} />

      {!hideFooter && <Footer24 />}

      <style jsx global>
        {Styles}
      </style>
    </>
  );
}

export default PageSimulador;
